import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';


@Component({
  selector: 'app-whats-app-template',
  templateUrl: './whats-app-template.component.html',
  styleUrls: ['./whats-app-template.component.css']
})
export class WhatsAppTemplateComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];
  p: number = 1;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any;
  content: any;
  metaWatsAppNum: any;
  client_id: any;
  client_password: any;
  apiURL: any;
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;

  showModal: boolean = false;
  selectedTemplate: any = null;
  mobileNumber: string = '';
  variables: string[] = [];
  bodyVariables: string[] = [];
  buttonVariables: string[] = [];
  buttonDetails: any[] = [];
  headerImageUrl: string = '';
  uploadedImageUrl: string = '';
  imageUploadProgress: number = 0;
  imageUploadType: 'upload' | 'url' = 'upload';
  selectedImageFile: File | null = null;
  showUserForm: boolean = false;
  previewText: string = '';
  templateComponents: any = {
    header: null,
    body: null,
    buttons: null,
    footer: null
  };
  approvedTemplate: any = [];
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  openCoverages = false;
  indexSelectedCoverage = 1;
  recordsperpage: number = 25;

  changeRecordPerPage(value) {
    this.recordsperpage = value;
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('19');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }
    this.loginservice.getmetaWhatsAppCredential(this.currentUser)
      .subscribe(
        data => {
          this.metaWatsAppNum = data['metaWatsAppNum'];
          this.client_id = data['client_id'];
          this.client_password = data['client_password'];
          this.apiURL = data['apiURL'];
        }, error => { alert('Network Error getmetaWhatsAppCredential API'); });

    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['IsActive'] = ''
    this.model['IsApproved'] = ''
    // this.displayedColumns = this.columnNames.map(x => x.id);
    this.getWhatsAppTemplate();
  }

  onDateChanged(type, event: IMyDateModel): void {
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getWhatsAppTemplate() {
    this.showLoader = true;
    // this.loginservice.getWhatsAppTemplate('', this.currentUser)
    // this.loginservice.getWhatsAppTemplateFromMeta()
    this.loginservice.getWhatsAppStoredTemplateFromMeta(this.currentUser, '')
      .subscribe(
        data => {
          if (data['data'].length > 0) {
            this.dataresult = data['data'];
            this.approvedTemplate = (data['data'] || []).filter(item => item.status && item.status.toUpperCase() === 'APPROVED');

            // this.content = data['readyToSend']['0']['MessageTemplate'];
          } else {
            this.dataresult = [];
            this.approvedTemplate = [];
          }
          this.showLoader = false;
        }, error => { alert('Network Error getWhatsAppStoredTemplateFromMeta API'); });
  }

  setreadyToSend(data, value) {
    this.showLoader = true;
    this.loginservice.setreadyToSend(data, value, 'whatsApp', this.currentUser)
      .subscribe(
        datas => {
          this.showLoader = false;
          if (datas['data'].length > 0) {
            this.dataresult = datas['data'];
            this.content = datas['readyToSend']['0']['MessageTemplate'];
          } else {
            this.dataresult = [];
          }
        }, error => { alert('Network Error setreadyToSend API'); });
  }



  search() {
    // if (this.model['bill_no'] == '') {
    //   if (this.model['start_date'] == '' || this.model['end_date'] == '') {
    //     alert('Please Select Start & End Date & Bill No.');
    //     this._flashMessagesService.show('Please Select Start & End Date & Bill No.', { cssClass: 'alert-danger' });
    //     return true;
    //   }
    // } else {
    //   if (this.model['start_date'] != '' && this.model['end_date'] == '') {
    //     alert('Please Select End Date');
    //     this._flashMessagesService.show('Please Select End Date', { cssClass: 'alert-danger' });
    //     return true;
    //   } else if (this.model['start_date'] == '' && this.model['end_date'] != '') {
    //     alert('Please Select Start Date');
    //     this._flashMessagesService.show('Please Select Start Date', { cssClass: 'alert-danger' });
    //     return true;
    //   }
    // }
    this.showLoader = true;
    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      IsActive: this.model['IsActive'],
      IsApproved: this.model['IsApproved']
    };

    // this.loginservice.getWhatsAppTemplateSearch(data)
    //   .subscribe(
    //     datas => {
    //       this.showLoader = false;
    //       if (datas['data'].length > 0) {
    //         this.dataresult = datas['data'];
    //         this.content = datas['readyToSend']['0']['MessageTemplate'];
    //       } else {
    //         this.dataresult = [];
    //       }
    //     });

  }

  reset() {
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['IsActive'] = ''
    this.model['IsApproved'] = ''
    this.ngOnInit();
  }


  save() {

  }


  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      return false;
    }
  }

  openModal() {
    this.showModal = true;
  }

  cancelUserForm() {
    this.showUserForm = false;
  }

  closeModal() {
    this.showModal = false;
    this.selectedTemplate = null;
    this.mobileNumber = '';
    this.variables = [];
    this.bodyVariables = [];
    this.buttonVariables = [];
    this.buttonDetails = [];
    this.headerImageUrl = '';
    this.uploadedImageUrl = '';
    this.imageUploadProgress = 0;
    this.imageUploadType = 'upload';
    this.selectedImageFile = null;
    this.templateComponents = { header: null, body: null, buttons: null, footer: null };
  }

  onTemplateChange() {
    if (!this.selectedTemplate) return;

    this.parseTemplateComponents();
    this.updatePreview();
  }

  parseTemplateComponents() {
    if (!this.selectedTemplate || !this.selectedTemplate.components) return;

    this.templateComponents = { header: null, body: null, buttons: null, footer: null };
    this.bodyVariables = [];
    this.buttonVariables = [];
    this.buttonDetails = [];
    this.headerImageUrl = '';
    this.uploadedImageUrl = '';
    this.imageUploadProgress = 0;
    this.imageUploadType = 'upload';
    this.selectedImageFile = null;

    this.selectedTemplate.components.forEach((component: any) => {
      const compType = component.component_type || component.type;
      switch (compType) {
        case 'HEADER':
          this.templateComponents.header = component;
          break;
        case 'BODY':
          this.templateComponents.body = component;
          const bodyMatches = component.text ? component.text.match(/\{\{\d+\}\}/g) : [];
          const bodyVarCount = bodyMatches ? bodyMatches.length : 0;
          for (let i = 0; i < bodyVarCount; i++) {
            this.bodyVariables.push('');
          }
          break;
        case 'BUTTONS':
          this.templateComponents.buttons = component;
          if (component.buttons) {
            component.buttons.forEach((btn: any, index: number) => {
              if (btn.has_variable == '1' || btn.has_variable == 1 ||
                (btn.button_url && btn.button_url.indexOf('{{') !== -1) ||
                (btn.url && btn.url.indexOf('{{') !== -1)) {
                this.buttonDetails.push({
                  text: btn.button_text || btn.text,
                  url: btn.button_url || btn.url,
                  type: btn.button_type || btn.type,
                  index: index
                });
                this.buttonVariables.push('');
              }
            });
          }
          break;
        case 'FOOTER':
          this.templateComponents.footer = component;
          break;
      }
    });
  }

  hasHeaderImage(): boolean {
    return this.templateComponents.header && this.templateComponents.header.format === 'IMAGE';
  }

  hasButtons(): boolean {
    return !!this.templateComponents.buttons;
  }

  updatePreview() {
    if (!this.templateComponents.body) return;

    let preview = this.templateComponents.body.text;
    this.bodyVariables.forEach((variable, index) => {
      const placeholder = '{{' + (index + 1) + '}}';
      const value = variable || '[Variable ' + (index + 1) + ']';
      preview = preview.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), value);
    });
    this.previewText = preview;
  }

  getButtonPreviewUrl(btnDetail: any, variableIndex: number): string {
    if (!btnDetail || !btnDetail.url) return '';
    let url = btnDetail.url || btnDetail.button_url;
    if (variableIndex >= 0 && variableIndex < this.buttonVariables.length) {
      const variable = this.buttonVariables[variableIndex] || '[value]';
      return url.replace(/\{\{1\}\}/g, variable);
    }
    return url;
  }

  getButtonVariableIndex(buttonIndex: number): number {
    let varIndex = 0;
    if (this.templateComponents.buttons && this.templateComponents.buttons.buttons) {
      for (let i = 0; i < buttonIndex; i++) {
        const btn = this.templateComponents.buttons.buttons[i];
        if (btn.has_variable == '1' || btn.has_variable == 1 ||
          (btn.button_url && btn.button_url.indexOf('{{') !== -1) ||
          (btn.url && btn.url.indexOf('{{') !== -1)) {
          varIndex++;
        }
      }
    }
    return varIndex;
  }

  onImageTypeChange(type: 'upload' | 'url') {
    this.imageUploadType = type;
    if (type === 'upload') {
      this.headerImageUrl = '';
      this.uploadedImageUrl = '';
    } else {
      this.selectedImageFile = null;
      this.uploadedImageUrl = '';
      this.imageUploadProgress = 0;
    }
  }

  onImageUrlChange() {
    this.headerImageUrl = this.headerImageUrl;
  }

  onImageFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    this.selectedImageFile = file;
    this.uploadImage(file);
  }

  uploadImage(file: File) {
    if (!this.selectedTemplate) {
      this._flashMessagesService.show('Please select a template first', { cssClass: 'alert-danger' });
      return;
    }
    const formData = new FormData();
    formData.append('image', file);
    formData.append('salon_id', this.currentUser.salon_id);
    formData.append('template_id', this.selectedTemplate.template_id);
    this.imageUploadProgress = 10;
    this.loginservice.uploadWhatsAppImage(formData, this.currentUser).subscribe(
      (response: any) => {
        if (response.status === 'success') {
          this.uploadedImageUrl = response.url;
          this.headerImageUrl = this.uploadedImageUrl;
          this.imageUploadProgress = 100;
          this._flashMessagesService.show('Image uploaded successfully', { cssClass: 'alert-success' });
        } else {
          this._flashMessagesService.show('Image upload failed', { cssClass: 'alert-danger' });
          this.imageUploadProgress = 0;
        }
      },
      error => {
        this._flashMessagesService.show('Image upload failed', { cssClass: 'alert-danger' });
        this.imageUploadProgress = 0;
      }
    );
  }

  onVariableChange() {
    this.updatePreview();
  }

  sendMessage() {
    if (!this.selectedTemplate || !this.mobileNumber) {
      this._flashMessagesService.show('Please select template and enter mobile number', { cssClass: 'alert-danger' });
      return;
    }

    // Combine all variables
    this.variables = [...this.bodyVariables, ...this.buttonVariables];

    this.loginservice.send_whatsapp(
      this.selectedTemplate.template_name,
      this.mobileNumber,
      this.variables,
      this.currentUser,
      this.headerImageUrl
    ).subscribe(
      datas => {

        if (datas['status'] === 'error') {
          this._flashMessagesService.show(datas['msg'], { cssClass: 'alert-warning' });
        }
        if (datas['status'] === 'low') {
          this._flashMessagesService.show(datas['msg'], { cssClass: 'alert-warning' });
        } else if (datas['error']) {
          this._flashMessagesService.show('Failed to send message: ' + datas['error']['message'], { cssClass: 'alert-danger' });
        } else {
          if (datas['updatedCredits']) {
            this.currentUser.credits = datas['updatedCredits'];
            this.loginservice.setLocalSession(this.currentUser, 'currentUser');
          }
          this.closeModal();
          this._flashMessagesService.show('WhatsApp Message Sent Successfully', { cssClass: 'alert-success' });
        }
      },
      error => {
        this._flashMessagesService.show('Network Error', { cssClass: 'alert-danger' });
      }
    );
  }

  addUser() {
    this.showUserForm = true;
  }

  trackByIndex(index: number): number {
    return index;
  }

}


// WEBPACK FOOTER //
// ./src/app/whats-app-template/whats-app-template.component.ts